var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("input", {
      attrs: { type: "hidden", name: "invoice_template_items" },
      domProps: { value: JSON.stringify(_vm.services) },
    }),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass:
          "portlet light portlet-fit invoice-template-details-portlet",
        on: { keydown: _vm.downKeyAdd },
      },
      [
        !_vm.formMode
          ? _c("div", { staticClass: "portlet-title" }, [
              _vm._m(0),
              _vm._v(" "),
              _vm._m(1),
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "portlet-body" }, [
          _vm.loading
            ? _c("div", [_vm._m(2)])
            : _c("div", [
                _c(
                  "table",
                  {
                    staticClass: "table table-bordered",
                    staticStyle: { "margin-bottom": "5px" },
                    attrs: { id: "invoice-template-details-table" },
                  },
                  [
                    _vm._m(3),
                    _vm._v(" "),
                    _c(
                      "draggable",
                      {
                        attrs: { tag: "tbody", handle: ".draggable-handle" },
                        on: { update: _vm.handleChange },
                        model: {
                          value: _vm.items,
                          callback: function ($$v) {
                            _vm.items = $$v
                          },
                          expression: "items",
                        },
                      },
                      _vm._l(_vm.items, function (item, index) {
                        return _c(
                          "tr",
                          {
                            key: index,
                            staticClass: "item-row",
                            class: {
                              "is-service": item.part_index === undefined,
                            },
                          },
                          [
                            _c(
                              "td",
                              {
                                staticClass: "width-min-nowrap",
                                class: {
                                  "draggable-handle":
                                    item.part_index === undefined,
                                },
                                staticStyle: {
                                  padding: "3px 8px",
                                  "vertical-align": "middle",
                                  "font-size": "22px",
                                  cursor: "move",
                                },
                              },
                              [
                                item.part_index === undefined
                                  ? _c("i", { staticClass: "fa fa-bars" })
                                  : _vm._e(),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "td",
                              {
                                staticClass: "width-min-nowrap text-center",
                                style: {
                                  padding:
                                    item.part_index === undefined
                                      ? "8px"
                                      : "3px 8px",
                                },
                              },
                              [
                                _c("div", [
                                  _c(
                                    "a",
                                    {
                                      staticClass:
                                        "btn btn-circle btn-icon-only btn-default tooltips mr-0",
                                      attrs: {
                                        "data-container": "body",
                                        "data-placement": "top",
                                        "data-original-title":
                                          "Retourner dans l'inventaire",
                                        href: "javascript:;",
                                        title:
                                          item.part_index === undefined
                                            ? "Supprimer"
                                            : "Retourner dans l'inventaire",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.removeItem(
                                            item.service_index,
                                            item.part_index
                                          )
                                        },
                                      },
                                    },
                                    [
                                      item.part_index === undefined
                                        ? _c("i", { staticClass: "icon-trash" })
                                        : _vm._e(),
                                      item.part_index !== undefined
                                        ? _c("span", [_vm._v("I")])
                                        : _vm._e(),
                                    ]
                                  ),
                                ]),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "td",
                              {
                                staticClass: "width-min-nowrap",
                                staticStyle: { "vertical-align": "top" },
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    attrs: {
                                      title:
                                        item.part_index === undefined
                                          ? "Service"
                                          : "Pièce",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                    " +
                                        _vm._s(
                                          item.part_index === undefined
                                            ? "S"
                                            : "P"
                                        ) +
                                        "\n                  "
                                    ),
                                  ]
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "td",
                              {
                                staticClass: "input",
                                staticStyle: {
                                  width: "400px",
                                  "min-width": "400px",
                                },
                              },
                              [
                                _c(
                                  "div",
                                  [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value:
                                            item.invoice_template_detail_invoice_template_id,
                                          expression:
                                            "item.invoice_template_detail_invoice_template_id",
                                        },
                                      ],
                                      attrs: { type: "hidden" },
                                      domProps: {
                                        value:
                                          item.invoice_template_detail_invoice_template_id,
                                      },
                                      on: {
                                        input: function ($event) {
                                          if ($event.target.composing) return
                                          _vm.$set(
                                            item,
                                            "invoice_template_detail_invoice_template_id",
                                            $event.target.value
                                          )
                                        },
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value:
                                            item.invoice_template_detail_service_id,
                                          expression:
                                            "item.invoice_template_detail_service_id",
                                        },
                                      ],
                                      attrs: { type: "hidden" },
                                      domProps: {
                                        value:
                                          item.invoice_template_detail_service_id,
                                      },
                                      on: {
                                        input: function ($event) {
                                          if ($event.target.composing) return
                                          _vm.$set(
                                            item,
                                            "invoice_template_detail_service_id",
                                            $event.target.value
                                          )
                                        },
                                      },
                                    }),
                                    _vm._v(" "),
                                    item.type == "service"
                                      ? _c("select-two-items", {
                                          ref: `select2-service-${item.service_index}`,
                                          refInFor: true,
                                          attrs: {
                                            endpoint: _vm.itemEndpoint,
                                            type: item.type,
                                            "initial-value": item
                                              .invoice_template_detail_item.id
                                              ? item.invoice_template_detail_item.id.toString()
                                              : "",
                                            "initial-display":
                                              item.invoice_template_detail_item
                                                .text,
                                            "add-form-base-end-point":
                                              _vm.baseEndpoint + "service/add",
                                            "add-form-title":
                                              "Ajout d'un service",
                                            "add-form-selector":
                                              "#form_service",
                                            "add-text-input-selector":
                                              "#service_name",
                                            "edit-form-base-end-point":
                                              _vm.baseEndpoint + "service/edit",
                                            "edit-form-title":
                                              "Modifier un service",
                                            "edit-form-selector":
                                              "#form_service",
                                            "edit-text-input-selector":
                                              "#service_name",
                                            "allow-add": _vm.allowAddServices,
                                            "allow-edit": _vm.allowEditServices,
                                            dropdownParent: _vm.formMode
                                              ? ".modal-invoice-template .modal-content"
                                              : "body",
                                          },
                                          on: {
                                            selected: function ($event) {
                                              return _vm.onSelect(
                                                item.service_index,
                                                item.part_index,
                                                $event
                                              )
                                            },
                                            clear: function ($event) {
                                              return _vm.onClear(
                                                item.service_index,
                                                item.part_index
                                              )
                                            },
                                          },
                                          model: {
                                            value:
                                              item.invoice_template_detail_item,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                item,
                                                "invoice_template_detail_item",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "item.invoice_template_detail_item",
                                          },
                                        })
                                      : item.type == "part"
                                      ? _c("select-two-items", {
                                          ref: `select2-part-${item.service_index}-${item.part_index}`,
                                          refInFor: true,
                                          attrs: {
                                            endpoint: _vm.itemEndpoint,
                                            type: item.type,
                                            "initial-value": item
                                              .invoice_template_detail_item.id
                                              ? item.invoice_template_detail_item.id.toString()
                                              : "",
                                            "initial-display":
                                              item.invoice_template_detail_item
                                                .text,
                                            "add-form-base-end-point":
                                              _vm.baseEndpoint + "part/add",
                                            "add-form-title":
                                              "Ajout d'une pièce",
                                            "add-form-selector": "#form_part",
                                            "add-text-input-selector":
                                              "#part_name",
                                            "edit-form-base-end-point":
                                              _vm.baseEndpoint + "part/edit",
                                            "edit-form-title":
                                              "Modifier une pièce",
                                            "edit-form-selector": "#form_part",
                                            "edit-text-input-selector":
                                              "#part_name",
                                            "allow-add": _vm.allowAddParts,
                                            "allow-edit": _vm.allowEditParts,
                                            dropdownParent: _vm.formMode
                                              ? ".modal-invoice-template .modal-content"
                                              : "body",
                                          },
                                          on: {
                                            selected: function ($event) {
                                              _vm.onSelect(
                                                item.service_index,
                                                item.part_index,
                                                $event
                                              )
                                              _vm.focus(index)
                                            },
                                            clear: function ($event) {
                                              return _vm.onClear(
                                                item.service_index,
                                                item.part_index
                                              )
                                            },
                                          },
                                          model: {
                                            value:
                                              item.invoice_template_detail_item,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                item,
                                                "invoice_template_detail_item",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "item.invoice_template_detail_item",
                                          },
                                        })
                                      : _vm._e(),
                                    _vm._v(" "),
                                    item.part_index === undefined
                                      ? _c(
                                          "small",
                                          {
                                            staticStyle: {
                                              "font-size": "15px",
                                            },
                                          },
                                          [
                                            _c(
                                              "a",
                                              {
                                                attrs: { href: "javascript:;" },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.addPart(
                                                      item.service_index
                                                    )
                                                  },
                                                },
                                              },
                                              [_vm._v("+ Ajouter pièce")]
                                            ),
                                            _vm._v(" "),
                                            _c("span", [
                                              _vm._v(
                                                " (" +
                                                  _vm._s(item.parts.length) +
                                                  "  " +
                                                  _vm._s(
                                                    item.parts.length > 1
                                                      ? "pièces"
                                                      : "pièce"
                                                  ) +
                                                  ")"
                                              ),
                                            ]),
                                          ]
                                        )
                                      : _vm._e(),
                                  ],
                                  1
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c("td", { staticClass: "input" }, [
                              _c("div", [
                                item.part_index === undefined
                                  ? _c("textarea", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value:
                                            item.invoice_template_detail_description,
                                          expression:
                                            "item.invoice_template_detail_description",
                                        },
                                      ],
                                      ref: "description-box",
                                      refInFor: true,
                                      staticClass: "form-control",
                                      staticStyle: {
                                        width: "100%",
                                        "min-height": "35px",
                                        resize: "vertical",
                                      },
                                      domProps: {
                                        value:
                                          item.invoice_template_detail_description,
                                      },
                                      on: {
                                        change: _vm.handleChange,
                                        input: [
                                          function ($event) {
                                            if ($event.target.composing) return
                                            _vm.$set(
                                              item,
                                              "invoice_template_detail_description",
                                              $event.target.value
                                            )
                                          },
                                          _vm.autoResize,
                                        ],
                                      },
                                    })
                                  : _c("textarea", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value:
                                            item.invoice_template_detail_description,
                                          expression:
                                            "item.invoice_template_detail_description",
                                        },
                                      ],
                                      ref: "description-box",
                                      refInFor: true,
                                      staticClass: "form-control",
                                      staticStyle: {
                                        width: "100%",
                                        height: "35px",
                                        "min-height": "35px",
                                        resize: "vertical",
                                      },
                                      domProps: {
                                        value:
                                          item.invoice_template_detail_description,
                                      },
                                      on: {
                                        change: _vm.handleChange,
                                        input: [
                                          function ($event) {
                                            if ($event.target.composing) return
                                            _vm.$set(
                                              item,
                                              "invoice_template_detail_description",
                                              $event.target.value
                                            )
                                          },
                                          _vm.autoResize,
                                        ],
                                      },
                                    }),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c(
                              "td",
                              {
                                staticClass: "width-min-nowrap input",
                                staticStyle: { width: "100px" },
                              },
                              [
                                _c("div", [
                                  _c("div", [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value:
                                            item.invoice_template_detail_qty,
                                          expression:
                                            "item.invoice_template_detail_qty",
                                        },
                                      ],
                                      ref: "qty",
                                      refInFor: true,
                                      staticClass:
                                        "form-control invoice_template_detail_qty select-on-focus",
                                      staticStyle: { width: "100px" },
                                      attrs: { id: "qty", type: "number" },
                                      domProps: {
                                        value: item.invoice_template_detail_qty,
                                      },
                                      on: {
                                        change: _vm.handleChange,
                                        input: function ($event) {
                                          if ($event.target.composing) return
                                          _vm.$set(
                                            item,
                                            "invoice_template_detail_qty",
                                            $event.target.value
                                          )
                                        },
                                      },
                                    }),
                                  ]),
                                ]),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "td",
                              {
                                staticClass: "width-min-nowrap input",
                                staticStyle: { width: "100px" },
                              },
                              [
                                item.part_index === undefined
                                  ? _c("div", [
                                      _c("div", [
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value:
                                                item.invoice_template_detail_hours,
                                              expression:
                                                "item.invoice_template_detail_hours",
                                            },
                                          ],
                                          ref: "hours",
                                          refInFor: true,
                                          staticClass:
                                            "form-control invoice_template_detail_hours select-on-focus",
                                          staticStyle: { width: "100px" },
                                          attrs: {
                                            id: "hours",
                                            type: "number",
                                          },
                                          domProps: {
                                            value:
                                              item.invoice_template_detail_hours,
                                          },
                                          on: {
                                            change: _vm.handleChange,
                                            input: function ($event) {
                                              if ($event.target.composing)
                                                return
                                              _vm.$set(
                                                item,
                                                "invoice_template_detail_hours",
                                                $event.target.value
                                              )
                                            },
                                          },
                                        }),
                                      ]),
                                    ])
                                  : _vm._e(),
                              ]
                            ),
                          ]
                        )
                      }),
                      0
                    ),
                    _vm._v(" "),
                    _c("tfoot", { staticStyle: { border: "none" } }, [
                      _c("tr", { staticStyle: { border: "none" } }, [
                        _c(
                          "td",
                          {
                            staticStyle: { border: "none" },
                            attrs: { colspan: "5" },
                          },
                          [
                            _c(
                              "button",
                              {
                                staticClass: "btn purple",
                                on: { click: _vm.addService },
                              },
                              [
                                _c("i", { staticClass: "fa fa-plus" }),
                                _vm._v(" Ajouter un service"),
                              ]
                            ),
                          ]
                        ),
                      ]),
                    ]),
                  ],
                  1
                ),
              ]),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "caption" }, [
      _c("i", { staticClass: "fa fa-list" }),
      _vm._v(" "),
      _c("span", { staticClass: "caption-subject bold uppercase" }, [
        _vm._v("Services et pièces"),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "tools" }, [
      _c("a", {
        staticClass: "collapse",
        attrs: {
          href: "javascript:;",
          "data-original-title": "",
          title: "Afficher / Cacher",
        },
      }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "text-center" }, [
      _c("span", { staticStyle: { "font-size": "22px" } }, [
        _c("i", { staticClass: "fa fa-refresh fa-spin" }),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v(" ")]),
        _vm._v(" "),
        _c("th", [_vm._v(" ")]),
        _vm._v(" "),
        _c("th", [_vm._v(" ")]),
        _vm._v(" "),
        _c("th", { staticStyle: { width: "400px", "min-width": "400px" } }, [
          _vm._v("Services et pièces"),
        ]),
        _vm._v(" "),
        _c("th", [_vm._v("Description")]),
        _vm._v(" "),
        _c("th", { staticClass: "width-min-nowrap" }, [_vm._v("Quantité")]),
        _vm._v(" "),
        _c("th", { staticClass: "width-min-nowrap" }, [_vm._v("Heures")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }